<template>
  <div v-if="typeof value === 'boolean'">
    <div v-show="value">
      <div class="is-flex align-center">
        <icon icon="plug" class="has-text-success tooltip"
          :data-tooltip="`The Power Supply is switched ON as at ${reading.read_at}`"/>
        Power Supply is ON
      </div>
    </div>
    <div v-show="!value">
      <div class="is-flex align-center">
        <icon icon="plug" class="has-text-danger tooltip"
          :data-tooltip="`The Power Supply is switched OFF as at ${reading.read_at}`"/>
        Power Supply is OFF
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    reading: {
      type: Object,
      required: true,
    },
    variableName: {
      type: String,
      required: true,
    },
  },
  computed: {
    value() {
      return this.reading.data[this.variableName]
    },
  },
}
</script>

<style scoped>

</style>